module.exports = __webpack_public_path__ + "static/media/Pirate_Cove.edbfd0bf.webp";